import { z } from 'zod';

const EnvSchema = z.object({
  VITE_API_BASE_URL: z
    .string()
    .url('VITE_API_BASE_URL must be a valid URL (e.g. https://admin-api.example.com)'),
  VITE_APP_TITLE: z.string().min(1).default('投放管理后台'),
});

type Env = z.infer<typeof EnvSchema>;

const parsed = EnvSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const formatted = parsed.error.issues
    .map((i) => `  - ${i.path.join('.') || '(root)'}: ${i.message}`)
    .join('\n');
  throw new Error(`[env] Invalid environment variables:\n${formatted}`);
}

export const env: Env = parsed.data;
